"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("../../../BaseQuery");
var utils_1 = require("../../../../utils");
var DxmList = /** @class */ (function (_super) {
    __extends(DxmList, _super);
    function DxmList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DxmList.prototype.getOptions = function () {
        var _a = this.queryOptions.options, options = _a === void 0 ? {} : _a;
        return (options.externalApi &&
            options.externalApi.options &&
            options.externalApi.options.dxm &&
            options.externalApi.options.dxm.list);
    };
    Object.defineProperty(DxmList.prototype, "listResponse", {
        get: function () {
            var externalApiOptions = this.queryOptions.options && this.queryOptions.options.externalApi;
            var externalApiResponse = this.getExternalApiResponse(externalApiOptions, this.executionOptions);
            return externalApiResponse && externalApiResponse.dxm && externalApiResponse.dxm.list;
        },
        enumerable: true,
        configurable: true
    });
    DxmList.prototype.getRawValue = function (executionOptions) {
        var rawValue = undefined;
        this.executionOptions = executionOptions;
        var response = this.listResponse;
        var options = this.options;
        if (options && response && response.values) {
            rawValue = response.values;
            var index = options.index, path = options.path;
            if (typeof index === 'number') {
                if (response.values.length > index) {
                    rawValue = response.values[index];
                    if (path) {
                        rawValue = utils_1.get(rawValue, path);
                    }
                }
                else {
                    rawValue = undefined;
                }
            }
        }
        return rawValue;
    };
    return DxmList;
}(BaseQuery_1.BaseQuery));
exports.DxmList = DxmList;
//# sourceMappingURL=DxmList.js.map